module.exports = __webpack_public_path__ + "img/matrix.c21f1fc7.png";